import m from 'moment';
import t from 'truncate';

import { isTimestampValid } from './time';

// Intl formatters

const NF = Intl.NumberFormat;

const intlLocale = 'en-US';
const intlOptions = {
  maximumFractionDigits: 8,
};

const validNumber = (v) => typeof v === 'number' && !Number.isNaN(v);

const intlNumber = (v, options = {}) => {
  const value = validNumber(v) ? v : 0;

  return new NF(intlLocale, { ...intlOptions, ...options }).format(value);
};

const intlCurrency = (v, options = {}) => {
  const value = validNumber(v) ? v : 0;

  if (Math.abs(v) < 1) {
    return new NF(intlLocale, { ...intlOptions, ...options }).format(value);
  }

  return new NF(intlLocale, options).format(value);
};

export const currencyUSD = (v) => intlCurrency(v, { style: 'currency', currency: 'USD' });

export const number = (v) => intlNumber(v);

export const integer = (v) => intlNumber(v, { minimumFractionDigits: 0, maximumFractionDigits: 0 });

export const second = (v) => `${number(v)}s`;

export const unitPerSecond = (v) => `${number(v)}/s`;

export const thPerSecond = (v) => `${number(v)} TH/s`;

export const trillion = (v) => `${number(v)}T`;

export const percent = (v) => `${intlNumber(v, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;

export const percentNative = (v) =>
  intlNumber(v, { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const percentPrecise = (v) =>
  intlNumber(v, { style: 'percent', minimumFractionDigits: 2, maximumFractionDigits: 3 });

export const signed = (v) => (v.includes('-') ? v : `+${v}`);

// date & time

export const dateTime = (v) => m.unix(v).format('YYYY-MM-DD HH:mm:ss');

export const dateTimeShort = (v) => m.unix(v).format('YYYY-MM-DD HH:mm');

export const timeDate = (v) => m.unix(v).format('HH:mm:ss YYYY-MM-DD');

export const date = (v) => m.unix(v).format('YYYY-MM-DD');

export const dateHumanize = (v) => m.unix(v).format('DD MMM YYYY');

export const dateShortHumanize = (v) => m.unix(v).format('MMM YYYY');

export const time = (v) => m.unix(v).format('HH:mm:ss');

export const fromNow = (v) => m.unix(v).fromNow();

export const unix = (v) => m(v).unix();

export const utcDateFormatted = (v) => m.unix(v).format('MMM D, YYYY');

export const utcString = (v) => {
  if (v && isTimestampValid(v)) {
    return m.unix(v).format();
  }

  return v;
};

// other

export const truncate = (v, l) => t(v, l, { ellipsis: null });

export const ellipsis = (v, l) => t(v, l);

export const round = (val, precision = 1) => {
  if (!validNumber(val) || !validNumber(precision)) {
    return val;
  }

  const multiplier = 10 ** precision;

  return Math.round(val * multiplier) / multiplier;
};

export const weekNumber = (v) => m.unix(v).isoWeek();
